import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function ClientsSearchFilter({
  search, onSearch, selectedFolder, onSelectFolder, folders,
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Cerca clienti..."
          className="pl-10 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white placeholder:text-zinc-600"
          data-testid="search-clients-input"
        />
      </div>
      <Select value={selectedFolder} onValueChange={onSelectFolder}>
        <SelectTrigger
          className="w-full sm:w-48 bg-[#0A0A0A] border-[#262626] text-white"
          data-testid="folder-filter"
        >
          <SelectValue placeholder="Tutte le cartelle" />
        </SelectTrigger>
        <SelectContent className="bg-[#171717] border-[#262626]">
          <SelectItem value="all" className="text-white hover:bg-[#1A1A1A]">Tutti</SelectItem>
          <SelectItem value="none" className="text-white hover:bg-[#1A1A1A]">Senza cartella</SelectItem>
          {folders.map((f) => (
            <SelectItem key={f.id} value={f.id} className="text-white hover:bg-[#1A1A1A]">
              {f.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
